import { subDays } from 'date-fns';

export type ActivityHistoryKind = 'message' | 'profile';

type ActivityHistoryWindow = {
  includedDays: number;
  addonDays: number;
};

// Profile activity tops out at 30 days, whatever the account pays.
export const ACTIVITY_HISTORY_WINDOWS = {
  message: { includedDays: 30, addonDays: 365 },
  profile: { includedDays: 7, addonDays: 30 },
} satisfies Record<ActivityHistoryKind, ActivityHistoryWindow>;

export type ActivityHistory = ActivityHistoryWindow & {
  heading: string;
  /** Unix seconds. */
  lookbackStart: number;
  /** Unix seconds. */
  addonLookbackStart: number;
};

const toUnixSeconds = (date: Date) => Math.floor(date.getTime() / 1000);

/** The window includes today, so a 7-day history starts 6 days back. */
export function activityHistory(kind: ActivityHistoryKind, now: Date = new Date()): ActivityHistory {
  const window = ACTIVITY_HISTORY_WINDOWS[kind];
  return {
    ...window,
    heading: kind === 'message' ? 'Message activity history' : 'Profile activity history',
    lookbackStart: toUnixSeconds(subDays(now, window.includedDays - 1)),
    addonLookbackStart: toUnixSeconds(subDays(now, window.addonDays - 1)),
  };
}
